// Formatare in romana, ora Romaniei.
const TZ = 'Europe/Bucharest';
const d = new Intl.DateTimeFormat('ro-RO', {
  timeZone: TZ,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
});
const dt = new Intl.DateTimeFormat('ro-RO', {
  timeZone: TZ,
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const n = new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 2 });
const lei = new Intl.NumberFormat('ro-RO', {
  style: 'currency',
  currency: 'RON',
  maximumFractionDigits: 2,
});
const month = new Intl.DateTimeFormat('ro-RO', {
  timeZone: 'UTC',
  month: 'short',
  year: 'numeric',
});

/** O zi 'YYYY-MM-DD' (fara ora): se formateaza in UTC, ca sa nu se mute pe ziua de dinainte. */
export const fmtDay = (v: string | null | undefined) =>
  v
    ? new Intl.DateTimeFormat('ro-RO', { timeZone: 'UTC' }).format(
        new Date(`${v.slice(0, 10)}T00:00:00Z`),
      )
    : '—';
export const fmtDate = (v: string | null | undefined) => (v ? d.format(new Date(v)) : '—');
export const fmtDateTime = (v: string | null | undefined) => (v ? dt.format(new Date(v)) : '—');
export const fmtMonth = (v: string | null | undefined) =>
  v ? month.format(new Date(`${v.slice(0, 10)}T00:00:00Z`)) : '—';
export const fmtNum = (v: number | string | null | undefined) =>
  v === null || v === undefined || v === '' ? '—' : n.format(Number(v));
export const fmtLei = (v: number | string | null | undefined) =>
  v === null || v === undefined || v === '' ? '—' : lei.format(Number(v));
/** Sume Stripe (in bani). */
export const fmtMinor = (v: number | null | undefined, currency = 'ron') =>
  v === null || v === undefined
    ? '—'
    : new Intl.NumberFormat('ro-RO', {
        style: 'currency',
        currency: currency.toUpperCase(),
      }).format(v / 100);

/** Zile ramase pana la o data (rotunjit in sus); 0 daca a trecut. */
export function daysLeft(v: string | null | undefined, now = Date.now()): number {
  if (!v) return 0;
  return Math.max(0, Math.ceil((new Date(v).getTime() - now) / 86_400_000));
}

export const STATUS_LABEL: Record<string, string> = {
  trialing: 'perioadă de probă',
  active: 'activ',
  past_due: 'plată restantă',
  canceled: 'anulat',
  incomplete: 'neconfirmat',
  incomplete_expired: 'expirat',
  unpaid: 'neplătit',
  paused: 'suspendat',
};

/** Acordul numeralului: 1 rezultat, 5 rezultate, 20 de rezultate, 101 rezultate. */
export function plural(n: number, one: string, many: string): string {
  if (n === 1) return `1 ${one}`;
  const r = Math.abs(n) % 100;
  return `${fmtNum(n)} ${r === 0 && n !== 0 ? 'de ' : r >= 20 ? 'de ' : ''}${many}`;
}
